import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import Baja from "../../Baja";
import GraficaPendientesTaller, {
  agrupaPorTaller,
  ejePendientes,
} from "./GraficaPendientesTaller";

function CortesPendientesRecibir() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS_PROCESOS_SALIDA = process.env.REACT_APP_URL_ARTICULOS_PROCESOS_SALIDA;
  const URL_DETALLE_HABILITACION_CORTES = process.env.REACT_APP_URL_DETALLE_HABILITACION_CORTES;
  const URL_PROCESOS_SALIDA = process.env.REACT_APP_URL_PROCESOS_SALIDA;
  const URL_PROCESOS_ENTRADA = process.env.REACT_APP_URL_PROCESOS_ENTRADA;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;

  // (2026-10) Los precios de maquila sólo los ve quien tiene el permiso
  // "Ver Precios en PDF Salida" (crt_pdfPrecios): columna Precio, pregunta y
  // precios de los PDF. Sin permiso no se pregunta y los PDF salen sin precios.
  const verPrecios = !!user.crt_pdfPrecios;
  const fmtMoney = (v) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(v || 0));

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 60);

  let comp8 = new Date();
  comp8.setDate(comp8.getDate() + 8);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");
  let compromiso8 = moment(comp8).format("YYYY-MM-DD");

  const [procesos, setProcesos] = useState([]);

  // (2026-10) Se puede abrir ya filtrada desde la gráfica "En Proceso de
  // Confección" de ListadoOrdenesCorte (?taller=&proceso=&desde=).
  const [filtroUrl] = useState(() => {
    const p = new URLSearchParams(window.location.search);
    return {
      taller: p.get("taller") || "",
      proceso: p.get("proceso") || "",
      desde: p.get("desde") || "",
    };
  });

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(
    filtroUrl.desde || startDate
  );
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [maquileros, setMaquileros] = useState([]);
  const [selectedMaquilero, setSelectedMaquilero] = useState(filtroUrl.taller);
  // L63 (2026-06) — filtro por cliente
  const [selectedCliente, setSelectedCliente] = useState("");
  // (2026-10) filtro por proceso (BORDADO, TALLER, ...)
  const [selectedProceso, setSelectedProceso] = useState(filtroUrl.proceso);
  // (2026-10) "tabla" o "grafica"
  const [vista, setVista] = useState("tabla");
  const [selectedVencido, setSelectedVencido] = useState("");
  // (2026-09) "Si" = sólo con pendiente (como antes), "No" = ya completos, "" = todos
  const [selectedPendientes, setSelectedPendientes] = useState("Si");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [idEdit, setIdEdit] = useState();
  const [fecha, setFecha] = useState();
  const [subtotal, setSubtotal] = useState();
  const [iva, setIva] = useState();
  const [descripcion, setDescripcion] = useState("");
  const [totalEdit, setTotalEdit] = useState();
  const [conceptosGastos, setConceptosGastos] = useState([]);
  const [selectedConcepto, setSelectedConcepto] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

useEffect(() => {
  async function getProcesos() {
    try {
      const headers = {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      };

      const salidasResp = await axios.get(
        `${URL_PROCESOS_SALIDA}FechasActivos/${selectedFechaInicio}/${selectedFechaFin}`,
        { headers }
      );

      const allProcesos = salidasResp.data || [];
      const idsSalidas = allProcesos.map((a) => a._id);

      const entradasResp = await axios.post(
        `${URL_PROCESOS_ENTRADA}BuscarPorProcesosSalida`,
        { procesosSalida: idsSalidas },
        { headers }
      );

      const allEntradas = entradasResp.data || [];

      const arrayTabla = allProcesos
        .filter(
          (a) =>
            a.cortes?.[0]?.status === "Abierto" &&
            a.status !== "Cancelado"
        )
        .sort((a, b) => (a.fechaCompromiso > b.fechaCompromiso ? 1 : -1))
        .map((a) => {
          const idSalida = a._id.toString();

          const entradasDeEsteProceso = allEntradas.filter((e) =>
            e.procesosSalida?.some((ps) => {
              const idPs = ps?._id ? ps._id.toString() : ps.toString();
              return idPs === idSalida;
            })
          );

          const entraron = entradasDeEsteProceso.reduce(
            (sum, e) => sum + Number(e.totalPiezas || 0),
            0
          );

          const segundas = entradasDeEsteProceso.reduce(
            (sum, e) => sum + Number(e.totalPiezasSegundas || 0),
            0
          );

          const faltantes = entradasDeEsteProceso.reduce(
            (sum, e) => sum + Number(e.totalPiezasFaltantes || 0),
            0
          );

          const cantidad = Number(a.totalPiezas || 0);
          const pendientes = Math.max(cantidad - entraron, 0);

          return {
            _id: a._id,
            numero: a.idProcesoSalida,
            precio: a.precio,
            totalGeneral: a.totalGeneral,
            status: a.status,
            fecha: a.fecha,
            fechaCompromiso: a.fechaCompromiso,
            maquilero: a.proveedores?.[0]?.nombre_comercial || "",
            idMaquilero: a.proveedores?.[0]?._id || "",
            pedido: a.pedidos?.[0]?.idPedido || "",
            pedidoCliente: a.pedidos?.[0]?.pedidoCliente || "",
            // nombre limpio para el combo de filtro
            clienteNombre: a.pedidos?.[0]?.clientes?.[0]?.nombre_comercial || "",
            // (2026-09) con el subcliente entre paréntesis, como en ListadoPedidos
            // (2026-10) y la subárea de la orden, también entre paréntesis
            cliente: (() => {
              const conDato = (v) => {
                const t = String(v ?? "").trim();
                return t && t.toUpperCase() !== "NA" ? t : "";
              };
              const nombre = String(a.pedidos?.[0]?.clientes?.[0]?.nombre_comercial || "").trim();
              const sub = conDato(a.pedidos?.[0]?.subCliente);
              const subArea = conDato(a.cortes?.[0]?.ordenesCorte?.[0]?.subArea);
              return [nombre, sub && `(${sub})`, subArea && `(${subArea})`]
                .filter(Boolean)
                .join(" ");
            })(),
            // L63 (2026-06) — id de cliente para filtro
            idCliente: a.pedidos?.[0]?.clientes?.[0]?._id || "",
            proceso: a.catalogoProcesos?.[0]?.name || "",
            idProceso: a.catalogoProcesos?.[0]?._id || "",
            corte: a.cortes?.[0]?.idCorte || "",
            ordenCorte: a.cortes?.[0]?.ordenesCorte?.[0]?.idOrdenesCorte || "",
            // (2026-11) OP = número de la orden de producción del corte (p. ej.
            // 167-A/2026) y los colores que lleva la salida
            op: (() => {
              const oc = a.cortes?.[0]?.ordenesCorte?.[0];
              const num = String(oc?.numero ?? "").trim();
              return num && num.toUpperCase() !== "NA" ? num : String(oc?.idOrdenesCorte ?? "");
            })(),
            color: (a.coloresSalida || []).join(", "),
            cantidad,
            entraron,
            pendientes,
            segundas,
            faltantes,
            totalEntradas: entraron + segundas,
            // (2026-07) MODELO = # Artículo (código) / Línea (subDepartamento)
            articulo: [
              a.articulos?.[0]?.codigo || "",
              a.articulos?.[0]?.subDepartamentos?.[0]?.name || "",
            ]
              .filter((x) => String(x).trim() !== "")
              .join(" / "),
            idArticulo: a.articulos?.[0]?._id || "",
          };
        });

      // (2026-09) Se guardan todos (con y sin pendiente); el combo
      // "Pendientes" decide cuáles se muestran. Antes se tiraban aquí los que
      // ya estaban en 0 y no había forma de verlos.
      setComments(arrayTabla);
      setProcesos(arrayTabla);
    } catch (err) {
      console.log(err);
    }
  }

  getProcesos();
}, [selectedFechaInicio, selectedFechaFin]);

  useEffect(() => {
  axios
      .get(`${URL_PROVEEDORES}Maquileros`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allMaquileros = response.data;
        setMaquileros(allMaquileros);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let total = 0;
  let totalEntradasTabla = 0;
  let totalPendientesTabla = 0;
  let totalTabla = 0;

  // (2026-10) Con la vista Gráfica, el PDF saca la gráfica de prendas
  // pendientes por taller (dibujada en el PDF, no una captura, para que se
  // imprima nítida) con los mismos filtros de la pantalla.
  async function PDFGrafica() {
    const datos = agrupaPorTaller(filtraProcesos(), endDate);
    if (!datos.length) {
      Swal.fire(
        "Sin datos",
        "No hay prendas pendientes con los filtros actuales",
        "warning"
      );
      return;
    }

    const brandColor = [42, 90, 138];
    const serie = [42, 120, 214];
    const tinta = [11, 11, 11];
    const tinta2 = [82, 81, 78];
    const tenue = [137, 135, 129];
    const guia = [235, 233, 227];
    const base = [195, 194, 183];
    const borde = [222, 224, 228];
    const critico = [208, 59, 59];
    const num = (n) => new Intl.NumberFormat("en-US").format(Number(n || 0));

    const doc = new jsPDF("landscape");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const ML = 12;
    const usableW = pageW - ML * 2;

    // ---- filtros aplicados, para el subtítulo
    const nombreDe = (lista, id, campoId, campoNombre) =>
      (lista.find((x) => String(x[campoId]) === String(id)) || {})[campoNombre] || "";
    const filtros = [
      selectedMaquilero &&
        `Taller: ${nombreDe(maquileros, selectedMaquilero, "_id", "nombre_comercial")}`,
      selectedProceso &&
        `Proceso: ${nombreDe(comments, selectedProceso, "idProceso", "proceso")}`,
      selectedCliente &&
        `Cliente: ${nombreDe(comments, selectedCliente, "idCliente", "clienteNombre")}`,
      selectedVencido &&
        `Vencimiento: ${
          { vencido: "Vencido", porVencer: "Próximo a vencer", aTiempo: "A tiempo" }[
            selectedVencido
          ] || selectedVencido
        }`,
      search && `Búsqueda: "${search}"`,
    ].filter(Boolean);

    // ---- Barra de título (mismo estilo que el PDF de la tabla)
    doc.setFillColor(...brandColor);
    doc.rect(0, 0, pageW, 26, "F");
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
    await new Promise((resolve) => {
      img2.onload = () => {
        const maxH = 16;
        const scale = maxH / img2.height;
        doc.addImage(img2, "png", 10, 5, img2.width * scale, maxH);
        resolve();
      };
      img2.onerror = () => resolve();
    });
    doc.setTextColor(255, 255, 255);
    doc.setFont(undefined, "bold").setFontSize(16);
    doc.text("Prendas Pendientes por Taller", pageW / 2, 13, { align: "center" });
    doc.setFont(undefined, "normal").setFontSize(9);
    doc.text(
      `Del ${selectedFechaInicio} al ${selectedFechaFin}${
        filtros.length ? "  ·  " + filtros.join("  ·  ") : ""
      }`,
      pageW / 2,
      21,
      { align: "center", maxWidth: pageW - 90 }
    );

    // ---- Tarjetas de resumen
    const tot = datos.reduce(
      (t, d) => ({
        pendientes: t.pendientes + d.pendientes,
        salidas: t.salidas + d.salidas,
        vencidas: t.vencidas + d.vencidas,
      }),
      { pendientes: 0, salidas: 0, vencidas: 0 }
    );
    const pctV =
      tot.pendientes > 0 ? Math.round((tot.vencidas / tot.pendientes) * 100) : 0;
    const tarjetas = [
      { titulo: "Prendas pendientes", valor: num(tot.pendientes), pie: "por entregar de los talleres" },
      { titulo: "Talleres con pendiente", valor: num(datos.length), pie: "con al menos una prenda" },
      { titulo: "Salidas con pendiente", valor: num(tot.salidas), pie: "salidas de proceso abiertas" },
      { titulo: "Prendas vencidas", valor: num(tot.vencidas), pie: `${pctV}% del pendiente, compromiso pasado`, alerta: true },
    ];
    const gap = 4;
    const tarjW = (usableW - gap * 3) / 4;
    const tarjY = 31;
    const tarjH = 17;
    tarjetas.forEach((t, i) => {
      const x = ML + i * (tarjW + gap);
      doc.setFillColor(255, 255, 255).setDrawColor(...borde).setLineWidth(0.25);
      doc.roundedRect(x, tarjY, tarjW, tarjH, 2, 2, "FD");
      let xt = x + 4;
      if (t.alerta) {
        // marca de alerta junto a la etiqueta (el color nunca va solo)
        doc.setFillColor(...critico);
        doc.triangle(xt, tarjY + 5.6, xt + 3, tarjY + 5.6, xt + 1.5, tarjY + 3, "F");
        xt += 4.2;
      }
      doc.setFont(undefined, "normal").setFontSize(8).setTextColor(...tinta2);
      doc.text(t.titulo, xt, tarjY + 5.4);
      doc.setFont(undefined, "bold").setFontSize(15).setTextColor(...tinta);
      doc.text(t.valor, x + 4, tarjY + 11.6);
      doc.setFont(undefined, "normal").setFontSize(7).setTextColor(...tenue);
      doc.text(t.pie, x + 4, tarjY + 15.2);
    });

    // ---- Gráfica de barras horizontales
    const { tope, ticks } = ejePendientes(datos[0].pendientes);
    const anchoEtiqueta = 58;
    const plotX = ML + anchoEtiqueta;
    const plotW = pageW - ML - plotX;
    const xDe = (v) => plotX + (tope > 0 ? (v / tope) * plotW : 0);
    let altoRenglon = 7;
    let grosor = 4.2;
    const espacioEje = 12; // ticks + título del eje
    const espacioPie = 12;

    const cortaTexto = (txt, ancho) => {
      let t = String(txt || "");
      if (doc.getTextWidth(t) <= ancho) return t;
      while (t.length > 1 && doc.getTextWidth(t + "…") > ancho) t = t.slice(0, -1);
      return t + "…";
    };

    const dibujaBloque = (filas, y0) => {
      const alto = filas.length * altoRenglon;
      // líneas guía (la del 0 un poco más marcada)
      ticks.forEach((t) => {
        doc.setDrawColor(...(t === 0 ? base : guia)).setLineWidth(t === 0 ? 0.3 : 0.2);
        doc.line(xDe(t), y0, xDe(t), y0 + alto);
      });
      filas.forEach((d, i) => {
        const yc = y0 + i * altoRenglon + altoRenglon / 2;
        doc.setFont(undefined, "normal").setFontSize(8).setTextColor(...tinta2);
        doc.text(cortaTexto(d.taller, anchoEtiqueta - 5), plotX - 3, yc + 1.1, {
          align: "right",
        });
        const w = Math.max(0.6, xDe(d.pendientes) - plotX);
        const yb = yc - grosor / 2;
        doc.setFillColor(...serie);
        // punta redondeada, base recta sobre el eje
        doc.roundedRect(plotX, yb, w, grosor, Math.min(1, w / 2), Math.min(1, w / 2), "F");
        doc.rect(plotX, yb, Math.min(w, 1.2), grosor, "F");
        doc.setFontSize(7.5).setTextColor(...tinta);
        doc.text(num(d.pendientes), plotX + w + 1.5, yc + 1);
      });
      // eje
      const yEje = y0 + alto + 4;
      doc.setFontSize(7).setTextColor(...tenue);
      ticks.forEach((t) => doc.text(num(t), xDe(t), yEje, { align: "center" }));
      doc.setFontSize(7.5);
      doc.text("Prendas pendientes de entrega", plotX + plotW / 2, yEje + 5, {
        align: "center",
      });
    };

    // primera hoja: título de la gráfica abajo de las tarjetas
    let y = tarjY + tarjH + 9;
    doc.setFont(undefined, "bold").setFontSize(11).setTextColor(...tinta);
    doc.text("Prendas pendientes por taller", ML, y);
    doc.setFont(undefined, "normal").setFontSize(8).setTextColor(...tenue);
    doc.text("De mayor a menor", ML, y + 4.5);
    y += 9;

    // si no caben en la hoja, se aprietan los renglones antes que partir la
    // gráfica; sólo con muchos talleres se pasa a otra hoja
    const disponible = pageH - espacioPie - espacioEje - y;
    if (datos.length * altoRenglon > disponible) {
      altoRenglon = Math.max(4.6, disponible / datos.length);
    }
    grosor = Math.min(4.2, altoRenglon * 0.6);

    let i = 0;
    while (i < datos.length) {
      const caben = Math.max(
        1,
        Math.floor((pageH - espacioPie - espacioEje - y) / altoRenglon)
      );
      dibujaBloque(datos.slice(i, i + caben), y);
      i += caben;
      if (i < datos.length) {
        doc.addPage();
        doc.setFont(undefined, "bold").setFontSize(11).setTextColor(...tinta);
        doc.text("Prendas pendientes por taller (continúa)", ML, 16);
        y = 24;
      }
    }

    // ---- Pie en todas las hojas
    const paginas = doc.internal.getNumberOfPages();
    for (let p = 1; p <= paginas; p++) {
      doc.setPage(p);
      doc.setDrawColor(...borde).setLineWidth(0.2);
      doc.line(ML, pageH - 9, pageW - ML, pageH - 9);
      doc.setFont(undefined, "normal").setFontSize(7.5).setTextColor(...tenue);
      doc.text(`Generado el ${moment().format("DD/MM/YYYY HH:mm")}`, ML, pageH - 5);
      doc.text(`Página ${p} de ${paginas}`, pageW - ML, pageH - 5, { align: "right" });
    }
    doc.setTextColor(0, 0, 0);
    doc.save("PrendasPendientesPorTaller.pdf");
  }

  async function PDFTabla() {
    if (vista === "grafica") return PDFGrafica();
    // (2026-07) Formato corporativo + Modelo (Línea/Código) + Precio (con permiso)
    const brandColor = [42, 90, 138];
    const lightBg = [237, 242, 247];
    const zebra = [248, 250, 252];

    let mostrarPrecios = false;
    if (verPrecios) {
      const r = await Swal.fire({
        title: "¿Mostrar precios en el PDF?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        reverseButtons: true,
      });
      mostrarPrecios = r.isConfirmed;
    }

    total = 0;
    totalEntradasTabla = 0;
    totalPendientesTabla = 0;
    let totalImporte = 0;

    const body = filtraProcesos()
      .map((c) => {
        total = total + c.cantidad;
        totalEntradasTabla = totalEntradasTabla + c.totalEntradas;
        totalPendientesTabla = totalPendientesTabla + c.pendientes;
        totalImporte = totalImporte + Number(c.totalGeneral || 0);
        // (2026-11) orden que pidió el cliente: OP y Color nuevos
        const row = [
          c.fecha,
          c.op,
          c.cliente,
          c.articulo,
          c.color,
          c.proceso,
          c.maquilero,
          c.fechaCompromiso,
          c.corte,
        ];
        if (mostrarPrecios) row.push(fmtMoney(c.precio));
        row.push(
          new Intl.NumberFormat("en-US").format(c.cantidad),
          new Intl.NumberFormat("en-US").format(c.totalEntradas),
          new Intl.NumberFormat("en-US").format(c.pendientes)
        );
        return row;
      });

    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();

    // Barra de título
    doc.setFillColor(brandColor[0], brandColor[1], brandColor[2]);
    doc.rect(0, 0, pageWidth, 26, "F");

    // Logo
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
    await new Promise((resolve) => {
      img2.onload = () => {
        const maxH = 16;
        const scale = maxH / img2.height;
        const w = img2.width * scale;
        doc.addImage(img2, "png", 10, 5, w, maxH);
        resolve();
      };
      img2.onerror = () => resolve();
    });

    doc.setTextColor(255, 255, 255);
    doc.setFont(undefined, "bold");
    doc.setFontSize(16);
    doc.text("Procesos Pendientes", pageWidth / 2, 13, { align: "center" });
    doc.setFont(undefined, "normal");
    doc.setFontSize(9);
    const nombreProceso =
      (comments.find((c) => c.idProceso === selectedProceso) || {}).proceso || "";
    doc.text(
      `Del ${selectedFechaInicio} al ${selectedFechaFin}${
        nombreProceso ? `  ·  Proceso: ${nombreProceso}` : ""
      }`,
      pageWidth / 2,
      21,
      { align: "center" }
    );
    doc.setTextColor(0, 0, 0);

    const head = [
      [
        "Fecha",
        "OP",
        "Cliente",
        "Modelo",
        "Color",
        "Proceso",
        "Taller",
        "Fecha Compromiso",
        "Corte",
        ...(mostrarPrecios ? ["Precio"] : []),
        "Cantidad",
        "Entradas",
        "Pendientes",
      ],
    ];

    const footRow = new Array(head[0].length).fill("");
    const idxCant = head[0].indexOf("Cantidad");
    footRow[head[0].indexOf("Corte")] = "Total";
    if (mostrarPrecios) footRow[head[0].indexOf("Precio")] = fmtMoney(totalImporte);
    footRow[idxCant] = new Intl.NumberFormat("en-US").format(total);
    footRow[idxCant + 1] = new Intl.NumberFormat("en-US").format(totalEntradasTabla);
    footRow[idxCant + 2] = new Intl.NumberFormat("en-US").format(totalPendientesTabla);

    doc.autoTable({
      head,
      body,
      foot: [footRow],
      startY: 30,
      margin: { left: 10, right: 10 },
      styles: { fontSize: 7, cellPadding: 1.4, valign: "middle" },
      headStyles: {
        fillColor: brandColor,
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "center",
      },
      footStyles: { fillColor: lightBg, textColor: [0, 0, 0], fontStyle: "bold" },
      alternateRowStyles: { fillColor: zebra },
      showFoot: "lastPage",
    });
    doc.save("ProcesosPendientes.pdf");
  }

  function excel() {
    const dataExcel = filtraProcesos().map((c) => {
      {
        return {
          Fecha: c.fecha,
          OP: c.op,
          Taller: c.maquilero,
          Proceso: c.proceso,
          Articulo: c.articulo,
          Color: c.color,
          FechaCompromiso: c.fechaCompromiso,
          Corte: c.corte,
          Cliente: c.cliente,
          PedidoCliente: c.pedidoCliente,
          Cantidad: c.cantidad,
          Entradas: c.totalEntradas,
          Pendientes: c.pendientes
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `ProcesosCorte-${selectedFechaInicio}-${selectedFechaFin}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: `ProcesosCorte`,
        sheetFilter: [
          "Fecha",
          "OP",
          "Taller",
          "Proceso",
          "Articulo",
          "Color",
          "FechaCompromiso",
          "Corte",
          "Cliente",
          "PedidoCliente",
          "Cantidad",
          "Entradas",
          "Pendientes",
        ],
        sheetHeader: [
          "Fecha",
          "OP",
          "Taller",
          "Proceso",
          "Articulo",
          "Color",
          "FechaCompromiso",
          "Corte",
          "Cliente",
          "PedidoCliente",
          "Cantidad",
          "Entradas",
          "Pendientes",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    total = 0;
    const data = filtraProcesos().map((c) => {
      {
        total = total + c.cantidad;
        const importePDF = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.total);
        return [
          c.fecha,
          c.maquilero,
          c.proceso,
          c.articulo,
          c.fechaCompromiso,
          c.corte,
          c.cliente,
          c.pedidoCliente,
          c.cantidad,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text("Procesos Pendientes", 20, 25);
    doc.autoTable({
      head: [
        [
          "Fecha",
          "Taller",
          "Proceso",
          "Articulo",
          "Fecha Comp.",
          "Corte",
          "Cliente",
          "Pedido Cliente",
          "Cantidad",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US").format(total),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Lista de Gastos",
          email: mailTo,
          fileName: "ListaGastos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras la lista de Gastos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "OP", field: "op", sortable: true },
    { name: "Taller", field: "maquilero", sortable: true },
    { name: "Proceso", field: "proceso", sortable: true },
    { name: "Modelo", field: "articulo", sortable: true },
    { name: "Color", field: "color", sortable: true },
    { name: "Fecha Compromiso", field: "fechaCompromiso", sortable: true },
    { name: "Corte", field: "corte", sortable: true },
    { name: "Cliente", field: "cliente", sortable: true },
    // { name: "Pedido Cliente", field: "pedidoCliente", sortable: true },
    ...(verPrecios
      ? [{ name: "Precio", field: "precio", sortable: true }]
      : []),
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Entradas", field: "totalEntradas", sortable: true },
    { name: "Pendientes", field: "pendientes", sortable: true },
  ];

  // (2026-10) Los mismos filtros para la tabla, el PDF, el Excel y el mail.
  // Antes las exportaciones sólo respetaban fechas, taller y cliente, y
  // sacaban también lo que la pantalla ocultaba (pendientes en 0, vencidos...).
  const filtraProcesos = () => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.maquilero.toLowerCase().includes(search.toLowerCase()) ||
          comment.proceso.toLowerCase().includes(search.toLowerCase()) ||
          comment.articulo.toLowerCase().includes(search.toLowerCase()) ||
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          // comment.pedidoCliente.toLowerCase().includes(search.toLowerCase())||
        comment.totalEntradas.toString().includes(search) ||
        comment.pendientes.toString().includes(search) ||
        comment.cantidad.toString().includes(search)
      );
    }

    if (selectedMaquilero) {
      computedComments = computedComments.filter((e) =>
        e.idMaquilero.includes(selectedMaquilero)
      );
    }

    // L63 (2026-06) — filtro por cliente
    if (selectedCliente) {
      computedComments = computedComments.filter(
        (e) => e.idCliente === selectedCliente
      );
    }

    if (selectedProceso) {
      computedComments = computedComments.filter(
        (e) => e.idProceso === selectedProceso
      );
    }

    if (selectedPendientes === "Si") {
      computedComments = computedComments.filter(
        (e) => Number(e.pendientes || 0) > 0
      );
    } else if (selectedPendientes === "No") {
      computedComments = computedComments.filter(
        (e) => Number(e.pendientes || 0) <= 0
      );
    }

    if (selectedVencido) {
      if (selectedVencido == "vencido") {
        computedComments = computedComments.filter(
          (e) => e.fechaCompromiso < endDate
        );
      }
      if (selectedVencido == "aTiempo") {
        computedComments = computedComments.filter(
          (e) => e.fechaCompromiso > compromiso8
        );
      }
      if (selectedVencido == "porVencer") {
        computedComments = computedComments.filter(
          (e) => e.fechaCompromiso < compromiso8 && e.fechaCompromiso > endDate
        );
      }
    }

    return computedComments;
  };

  const commentsData = useMemo(() => {
    let computedComments = filtraProcesos();

    setTotalItems(computedComments.length);

 //Sorting comments
    // (2026-10) Precio y Corte son números: iban por localeCompare (de texto) y
    // el orden no funcionaba. Los números se comparan como número y lo demás
    // como texto (con "10" después de "9").
    const NUMERICOS = ["precio", "corte", "cantidad", "totalEntradas", "pendientes"];
    if (sorting.field) {
      const f = sorting.field;
      const dir = sorting.order === "desc" ? -1 : 1;
      computedComments = [...computedComments].sort((a, b) =>
        NUMERICOS.includes(f)
          ? dir * ((parseFloat(a[f]) || 0) - (parseFloat(b[f]) || 0))
          : dir *
            String(a[f] ?? "").localeCompare(String(b[f] ?? ""), "es", {
              numeric: true,
              sensitivity: "base",
            })
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedMaquilero,
    selectedCliente,
    selectedProceso,
    selectedVencido,
    selectedPendientes,
  ]);

  function jalaInfo(id, subtotal, iva, total, concepto, descripcion, fecha) {
    setIdEdit(id);
    setSubtotal(subtotal);
    setIva(iva);
    setTotalEdit(total);
    setSelectedConcepto(concepto);
    setDescripcion(descripcion);
    setFecha(fecha);
    toggleEdit();
  }

  async function PDFOCPS(
  id,
  numero,
  proceso,
  maquilero,
  pedido,
  fechaCompromiso,
  cantidad,
  precio,
  totalGeneral,
  fecha,
  idArticulo,
  ordenCorte,
  cliente
) {

  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };

  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const getFirstName = (arr) => s(arr?.[0]?.name);
  const getArticuloCodigo = (a) => s(a?.articulos?.[0]?.codigo);
  const getArticuloDescripcion = (a) => s(a?.articulos?.[0]?.descripcion);
  const getArticuloLinea = (a) => s(a?.articulos?.[0]?.subDepartamentos?.[0]?.name);
  const getArticuloId = (a) => s(a?.articulos?.[0]?._id);

  const chunk = (arr, size) => {
    const out = [];
    for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  };

  const collatorES = new Intl.Collator("es", {
    sensitivity: "base",
    numeric: true,
  });

  const isSinVar = (name) => {
    const t = s(name).trim().toLowerCase();
    return !t || t === "sin variante" || t === "na";
  };

  const getImageAsDataURL = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        } catch (e) {
          reject(e);
        }
      };
      img.onerror = reject;
      img.src = url;
    });

  try {
    // ================= PREGUNTA SI VA CON PRECIOS =================
    // (2026-10) sólo se pregunta a quien tiene permiso de ver precios
    let mostrarPrecios = false;
    if (verPrecios) {
      const respPrecios = await Swal.fire({
        title: "¿Mostrar precios en el PDF?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        reverseButtons: true,
      });
      mostrarPrecios = respPrecios.isConfirmed;
    }

    const { data: allArticulosCorte } = await axios.get(
      `${URL_ARTICULOS_PROCESOS_SALIDA}/proceso/${id}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const doc = new jsPDF({ orientation: "landscape" });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginLeft = 15;
    const marginTop = 15;
    const marginBottom = 15;

    let currentY = 55;

    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
    };

    // ===== (2026-07) FORMATO CORPORATIVO — paleta =====
    const brandColor = [42, 90, 138];
    const lightBg = [245, 247, 250];
    const borderColor = [210, 216, 224];
    const labelColor = [110, 120, 135];
    const stripeBg = [251, 252, 253];
    const drawLabel = (label, value, lblX, valX, y) => {
      doc.setFont(undefined, "bold");
      doc.setTextColor(...labelColor);
      doc.setFontSize(8.5);
      doc.text(label, lblX, y);
      doc.setFont(undefined, "normal");
      doc.setTextColor(0);
      doc.setFontSize(9.5);
      doc.text(String(value ?? "").trim() || "—", valX, y);
    };

    // ===== Logo (izquierda) =====
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
    await new Promise((resolve) => {
      img2.onload = () => {
        const maxH = 14;
        const scale = maxH / img2.height;
        const w = img2.width * scale;
        doc.addImage(img2, "png", marginLeft, 8, w, maxH);
        resolve();
      };
      img2.onerror = () => resolve();
    });

    // ===== Título (derecha) + línea azul =====
    doc.setFont(undefined, "bold");
    doc.setFontSize(16);
    doc.setTextColor(...brandColor);
    doc.text(`SALIDA PROCESO # ${s(numero)}`, pageWidth - marginLeft, 18, {
      align: "right",
    });
    doc.setTextColor(0);
    doc.setDrawColor(...brandColor);
    doc.setLineWidth(0.6);
    doc.line(marginLeft, 26, pageWidth - marginLeft, 26);
    doc.setLineWidth(0.2);
    doc.setDrawColor(0);

    // ===== Card de datos (2 columnas) =====
    const cardY = 29;
    const cardW = pageWidth - marginLeft * 2;
    const cardH = mostrarPrecios ? 33 : 24;
    doc.setDrawColor(...borderColor);
    doc.setFillColor(...lightBg);
    doc.roundedRect(marginLeft, cardY, cardW, cardH, 1.5, 1.5, "FD");
    doc.setDrawColor(0);

    const lblX_L = marginLeft + 3;
    const valX_L = marginLeft + 26;
    const baseY = cardY + 6;
    drawLabel("Fecha:", s(fecha), lblX_L, valX_L, baseY);
    drawLabel("Cliente:", s(cliente), lblX_L, valX_L, baseY + 5);
    drawLabel("Proceso:", s(proceso), lblX_L, valX_L, baseY + 10);
    drawLabel("Taller:", s(maquilero), lblX_L, valX_L, baseY + 15);

    const colMidX = pageWidth / 2 + 5;
    drawLabel("Salida:", s(numero), colMidX, colMidX + 28, baseY);
    drawLabel("Pedido:", s(pedido), colMidX, colMidX + 28, baseY + 5);
    drawLabel("Orden Corte:", s(ordenCorte), colMidX, colMidX + 28, baseY + 10);
    drawLabel("Compromiso:", s(fechaCompromiso), colMidX, colMidX + 28, baseY + 15);

    // ===== Resumen de precios (dentro del card) =====
    if (mostrarPrecios) {
      const subtotalR = sn(totalGeneral, 0);
      const ivaR = subtotalR * 0.16;
      const totalR = subtotalR + ivaR;
      const fmt = (n) =>
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(n);
      doc.setFont(undefined, "bold");
      doc.setTextColor(...brandColor);
      doc.setFontSize(9);
      doc.text(
        `Piezas: ${sn(cantidad, 0)}     Precio: ${fmt(sn(precio, 0))}     Subtotal: ${fmt(
          subtotalR
        )}     IVA: ${fmt(ivaR)}     Total: ${fmt(totalR)}`,
        lblX_L,
        baseY + 23
      );
      doc.setTextColor(0);
      doc.setFont(undefined, "normal");
    }

    // El contenido arranca debajo del card
    currentY = cardY + cardH + 6;

    // ================= AGRUPAR POR ÁREA / ARTÍCULO =================
    const gruposMap = {};

    allArticulosCorte.forEach((a) => {
      const areaSan = getFirstName(a.areasClientes) || "Sin Área";
      // (2026-07) Modelo = Código / Línea (subDepartamento) — solo estos dos, código primero
      const articuloSan = [getArticuloCodigo(a), getArticuloLinea(a)]
        .filter((x) => x)
        .join(" / ");
      const articulo = articuloSan || "Artículo sin nombre";
      const articuloId = getArticuloId(a) || "sin-id";

      const clave = `${areaSan}||${articulo}||${articuloId}`;

      if (!gruposMap[clave]) gruposMap[clave] = [];
      gruposMap[clave].push(a);
    });

    const ordenTallas = ["2XCH","XXCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","6XG","ESP","VARIOS","UNITALLA","1","2","3","4","4-6","5","6","7","8","8-10","9","10","10-12","11","12","13","14","14-16","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56","57","58","59","60","61","62"];

    for (const clave in gruposMap) {
      const grupo = gruposMap[clave];
      const [areaNombre, articuloNombre] = clave.split("||");

      ensureRoom(20);

      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      doc.text(
        `Área: ${s(areaNombre)} - Modelo: ${s(articuloNombre)}`,
        marginLeft,
        currentY
      );
      currentY += 5;

      doc.setFont(undefined, "normal");
      doc.setFontSize(9);

      // ===== AGRUPAR POR COLOR -> VARIANTE -> TALLA =====
      const data = {};
      const totalVariante = {};
      const tallasMap = new Map();

      grupo.forEach((a) => {
        const color = getFirstName(a.colores) || "Sin color";
        const tallaName = s(a?.tallas?.[0]?.name?.trim()) || "Sin talla";
        const varianteNameRaw = s(a?.tallas?.[0]?.variantesTallas?.[0]?.name?.trim());
        const varianteName = varianteNameRaw ? varianteNameRaw : "Sin variante";
        const cantidad = sn(a?.cantidadSalida, 0);

        if (!data[color]) data[color] = {};
        if (!data[color][varianteName]) data[color][varianteName] = {};
        if (!data[color][varianteName][tallaName]) data[color][varianteName][tallaName] = 0;

        data[color][varianteName][tallaName] += cantidad;

        if (!totalVariante[color]) totalVariante[color] = {};
        if (!totalVariante[color][varianteName]) totalVariante[color][varianteName] = 0;

        totalVariante[color][varianteName] += cantidad;

        tallasMap.set(tallaName, true);
      });

      Object.keys(data).forEach((color) => {
        Object.keys(data[color] || {}).forEach((variante) => {
          const tot = sn(totalVariante?.[color]?.[variante], 0);
          if (tot <= 0) {
            delete data[color][variante];
            if (totalVariante[color]) delete totalVariante[color][variante];
          }
        });

        if (!Object.keys(data[color] || {}).length) {
          delete data[color];
          delete totalVariante[color];
        }
      });

      const tallasOrdenadas = Array.from(tallasMap.keys()).sort((a, b) => {
        const indexA = ordenTallas.indexOf(a);
        const indexB = ordenTallas.indexOf(b);
        return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
      });

      let totalPiezasGrupo = 0;
      Object.keys(totalVariante || {}).forEach((color) => {
        Object.keys(totalVariante[color] || {}).forEach((variante) => {
          totalPiezasGrupo += sn(totalVariante[color][variante], 0);
        });
      });

      const usableWidth = pageWidth - marginLeft * 2;
      const colorW = 32;
      const totalW = 12;
      const minTallaW = 5.8;

      const maxTallasPerRow = Math.max(
        1,
        Math.floor((usableWidth - colorW - totalW) / minTallaW)
      );

      const chunkSize = Math.max(1, Math.min(maxTallasPerRow, tallasOrdenadas.length));
      const tallasChunks = chunk(tallasOrdenadas, chunkSize);
      const colores = Object.keys(data);

      for (let ci = 0; ci < tallasChunks.length; ci++) {
        const chunkTallas = tallasChunks[ci];
        const nTallas = chunkTallas.length;
        const tallaW = (usableWidth - colorW - totalW) / Math.max(1, nTallas);

        const colStyles = {
          0: { cellWidth: colorW },
          [1 + nTallas]: { cellWidth: totalW },
        };

        for (let i = 0; i < nTallas; i++) {
          colStyles[1 + i] = { cellWidth: tallaW };
        }

        const headChunk = [["Color", ...chunkTallas, "Total"]];
        const bodyChunk = [];

        for (const color of colores) {
          const variantesRaw = Object.keys(data[color] || {});
          const variantes = variantesRaw.sort((a, b) => {
            const aSin = isSinVar(a);
            const bSin = isSinVar(b);

            if (aSin && !bSin) return -1;
            if (!aSin && bSin) return 1;

            const cleanA = s(a).trim();
            const cleanB = s(b).trim();

            const baseA = cleanA.split(/[+-]/)[0].trim();
            const baseB = cleanB.split(/[+-]/)[0].trim();

            const baseCompare = collatorES.compare(baseA, baseB);
            if (baseCompare !== 0) return baseCompare;

            const aHasPlus = cleanA.includes("+");
            const bHasPlus = cleanB.includes("+");
            const aHasMinus = cleanA.includes("-");
            const bHasMinus = cleanB.includes("-");

            if (aHasPlus && !bHasPlus) return -1;
            if (!aHasPlus && bHasPlus) return 1;

            if (aHasMinus && !bHasMinus) return -1;
            if (!aHasMinus && bHasMinus) return 1;

            const numA = parseInt(cleanA.match(/[+-]\s*(\d+)/)?.[1] || 0, 10);
            const numB = parseInt(cleanB.match(/[+-]\s*(\d+)/)?.[1] || 0, 10);

            return numA - numB;
          });

          let firstVar = true;

          for (const variante of variantes) {
            const totVar = sn(totalVariante?.[color]?.[variante], 0);
            if (totVar <= 0) continue;

            const row = new Array(1 + nTallas + 1).fill("");
            const tituloVar = isSinVar(variante) ? "" : s(variante);
            const colorTxt = firstVar ? s(color) : "";

            row[0] = tituloVar
              ? colorTxt
                ? `${colorTxt}\n${tituloVar}`
                : tituloVar
              : colorTxt
              ? colorTxt
              : "";

            chunkTallas.forEach((talla, idx) => {
              const val = sn(data?.[color]?.[variante]?.[talla], 0);
              row[1 + idx] = val > 0 ? String(val) : "";
            });

            row[row.length - 1] = String(totVar);

            const tieneAlgoEnChunk =
              row.slice(1, 1 + nTallas).some((x) => String(x || "").trim() !== "") ||
              String(row[0] || "").trim() !== "";

            if (tieneAlgoEnChunk) bodyChunk.push(row);

            firstVar = false;
          }
        }

        ensureRoom(22);

        doc.autoTable({
          head: headChunk,
          body: bodyChunk,
          startY: currentY,
          margin: { left: marginLeft, right: marginLeft },
          tableWidth: usableWidth,
          styles: {
            fontSize: 7.5,
            cellPadding: 0.2,
            valign: "middle",
            halign: "center",
            overflow: "linebreak",
          },
          headStyles: {
            fillColor: brandColor,
            textColor: [255, 255, 255],
            fontStyle: "bold",
          },
          columnStyles: colStyles,
          didParseCell: (hookData) => {
            if (hookData.section === "body" && hookData.column.index === 0) {
              hookData.cell.styles.halign = "left";
              const raw = hookData.cell.raw;
              const txt = typeof raw === "string" ? raw : raw?.content || "";
              if (txt && String(txt).includes("\n")) {
                hookData.cell.styles.fontStyle = "bold";
              }
            }
          },
        });

        currentY = doc.autoTable.previous.finalY + 4;

        if (tallasChunks.length > 1) {
          doc.setFontSize(8);
          doc.setFont(undefined, "italic");
          doc.text(
            `Tallas ${ci + 1}/${tallasChunks.length}`,
            pageWidth - marginLeft,
            currentY,
            { align: "right" }
          );
          doc.setFont(undefined, "normal");
          currentY += 5;
        }
      }

      // ===== RESUMEN POR GRUPO =====
      ensureRoom(8);
      doc.setFont(undefined, "bold");
      doc.setFontSize(9);
      doc.text(`Total piezas de este modelo: ${totalPiezasGrupo}`, marginLeft, currentY);
      currentY += 6;

      // ================= BORDADOS =================
      const primer = grupo.find((a) => a.articulosPedido?.[0]?.bordados?.length > 0);
      const bordados = primer?.articulosPedido?.[0]?.bordados || [];

      if (bordados.length) {
        ensureRoom(20);

        doc.setFont(undefined, "bold");
        doc.setFontSize(9);
        doc.text("Bordados:", marginLeft, currentY);
        currentY += 4;

        let currentX = marginLeft;
        let maxYInRow = 0;
        const imageMargin = 8;
        // x3: bordados 3 veces más grandes (2026-06)
        const maxImageHeight = 18 * 3;
        const maxImageWidth = 28 * 3;

        for (const b of bordados) {
          try {
            const imageUrl = `https://res.cloudinary.com/lynqro/image/upload/${b.public_id}`;
            const dataUrl = await getImageAsDataURL(imageUrl);

            await new Promise((resolve) => {
              const img = new Image();
              img.src = dataUrl;
              img.onload = () => {
                const ratio = Math.min(
                  maxImageWidth / img.width,
                  maxImageHeight / img.height
                );
                const imgW = img.width * ratio;
                const imgH = img.height * ratio;

                if (currentX + imgW > pageWidth - marginLeft) {
                  currentX = marginLeft;
                  currentY += maxYInRow + 10;
                  maxYInRow = 0;
                }

                doc.addImage(dataUrl, "PNG", currentX, currentY, imgW, imgH);
                doc.setFont(undefined, "normal");
                doc.setFontSize(9.5);

                const obs = s(b.observacion);
                if (obs) {
                  const obsLines = doc.splitTextToSize(obs, imgW);
                  doc.text(obsLines, currentX, currentY + imgH + 3);
                  const textHeight = obsLines.length * 3;
                  maxYInRow = Math.max(maxYInRow, imgH + textHeight + 5);
                } else {
                  maxYInRow = Math.max(maxYInRow, imgH + 5);
                }

                currentX += imgW + imageMargin;
                resolve();
              };
              img.onerror = () => resolve();
            });
          } catch (err) {
            console.warn("No se pudo mostrar bordado:", b.public_id);
          }
        }

        currentY += maxYInRow + 8;
      }

      ensureRoom(6);
      doc.setDrawColor(220);
      doc.line(marginLeft, currentY, pageWidth - marginLeft, currentY);
      doc.setDrawColor(0);
      currentY += 6;
    }

    // ================= HABILITACIONES =================
    try {
      const { data: habilitaciones } = await axios.get(
        `${URL_DETALLE_HABILITACION_CORTES}/proceso/${id}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      ensureRoom(20);

      doc.setFont(undefined, "bold");
      doc.setFontSize(11);
      doc.text("Habilitaciones", marginLeft, currentY);
      currentY += 5;

      if (habilitaciones.length) {
        const tablaHabilitaciones = habilitaciones.map((a) => [
          a.habilitacionCortes?.[0]?.fecha || "-",
          `${a.habilitacion?.[0]?.nombre || ""} ${a.habilitacion?.[0]?.descripcion || ""}`.trim(),
          sn(a.cantidad, 0),
        ]);

        doc.autoTable({
          head: [["Fecha", "Descripción", "Cantidad"]],
          body: tablaHabilitaciones,
          startY: currentY,
          margin: { left: marginLeft, right: marginLeft },
          styles: {
            fontSize: 8.5,
            cellPadding: 0.5,
            valign: "middle",
            halign: "center",
          },
          headStyles: {
            fillColor: brandColor,
            textColor: [255, 255, 255],
            fontStyle: "bold",
          },
          columnStyles: {
            0: { cellWidth: 35 },
            1: { cellWidth: pageWidth - marginLeft * 2 - 55 },
            2: { cellWidth: 20 },
          },
          didParseCell: (hookData) => {
            if (hookData.section === "body" && hookData.column.index === 1) {
              hookData.cell.styles.halign = "left";
            }
          },
        });

        currentY = doc.autoTable.previous.finalY + 8;
      } else {
        doc.setFont(undefined, "normal");
        doc.setFontSize(9);
        doc.text("No hay habilitaciones registradas.", marginLeft, currentY);
        currentY += 6;
      }
    } catch (err) {
      console.warn("No se pudieron cargar habilitaciones");
    }

    // ============ FOOTER — paginación (formato corporativo) ============
    try {
      const pageCount = doc.internal.getNumberOfPages();
      for (let p = 1; p <= pageCount; p++) {
        doc.setPage(p);
        doc.setFontSize(8);
        doc.setTextColor(...labelColor);
        doc.text(
          `Salida Proceso #${s(numero)}  ·  ${s(cliente)}  ·  Página ${p} de ${pageCount}`,
          pageWidth / 2,
          pageHeight - 5,
          { align: "center" }
        );
        doc.setTextColor(0);
      }
    } catch (errFooter) {
      console.warn("No se pudo dibujar footer:", errFooter);
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDF:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={7}>
                    <Button
                      size="sm"
                      href="/MenuProduccion"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Col>
                  <Col md={5}>
                    <ButtonGroup id="logoutBoton">
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={PDFTabla}
                      >
                        PDF <i class="far fa-file-pdf"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={toggleMail}
                      >
                        eMail <i class="fas fa-at"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="primary"
                        onClick={excel}
                      >
                        Excel <i class="far fa-file-excel"></i>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
                <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                  <ModalHeader toggle={toggleMail}>
                    <h4>Enviar Lista de Gastos</h4>
                  </ModalHeader>
                  <ModalBody>
                    <Label className="mr-sm-2">Email</Label>
                    <Input
                      className="col-sm-12"
                      type="text"
                      value={mailTo}
                      required
                      onChange={(e) => {
                        setMailTo(e.target.value);
                      }}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button size="sm" color="success" onClick={enviaMail}>
                      Enviar
                    </Button>
                  </ModalFooter>
                </Modal>
                <br />
                <h3 align="center">Procesos Pendientes</h3>
                {/* (2026-10) cambiar entre la tabla y la gráfica por taller */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: 10,
                  }}
                >
                  <ButtonGroup size="sm">
                    <Button
                      color="primary"
                      outline={vista !== "tabla"}
                      onClick={() => setVista("tabla")}
                    >
                      <i className="fas fa-table"></i> Tabla
                    </Button>
                    <Button
                      color="primary"
                      outline={vista !== "grafica"}
                      onClick={() => setVista("grafica")}
                    >
                      <i className="fas fa-chart-bar"></i> Gráfica
                    </Button>
                  </ButtonGroup>
                </div>
                <Row>
                  <Col md={2}>
                    <Label>Fecha Inicio</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaInicio}
                      onChange={(e) => {
                        setSelectedFechaInicio(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Fecha Fin</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaFin}
                      onChange={(e) => {
                        setSelectedFechaFin(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Taller</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedMaquilero}
                      onChange={(e) => {
                        setSelectedMaquilero(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {maquileros
                        .sort((a, b) =>
                          a.nombre_comercial > b.nombre_comercial ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre_comercial}</option>
                          );
                        })}
                    </Input>
                  </Col>

                  {/* (2026-10) filtro por Proceso (sale de lo que hay en el periodo) */}
                  <Col md={2}>
                    <Label>Proceso</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedProceso}
                      onChange={(e) => {
                        setSelectedProceso(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {Array.from(
                        new Map(
                          (comments || [])
                            .filter((c) => c.idProceso && c.proceso)
                            .map((c) => [c.idProceso, c.proceso])
                        ).entries()
                      )
                        .sort((a, b) => (a[1] > b[1] ? 1 : -1))
                        .map(([id, name]) => (
                          <option value={id} key={id}>
                            {name}
                          </option>
                        ))}
                    </Input>
                  </Col>

                  {/* L63 (2026-06) — filtro por Cliente (construido desde los comments) */}
                  <Col md={2}>
                    <Label>Cliente</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedCliente}
                      onChange={(e) => {
                        setSelectedCliente(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {Array.from(
                        new Map(
                          (comments || [])
                            .filter((c) => c.idCliente && c.cliente)
                            .map((c) => [c.idCliente, c.clienteNombre || c.cliente])
                        ).entries()
                      )
                        .sort((a, b) => (a[1] > b[1] ? 1 : -1))
                        .map(([id, name]) => (
                          <option value={id} key={id}>
                            {name}
                          </option>
                        ))}
                    </Input>
                  </Col>

                  <Col md={1}>
                    <Label>Vencimiento</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedVencido}
                      onChange={(e) => {
                        setSelectedVencido(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="vencido">Vencido</option>
                      <option value="porVencer">Proximo a Venceer</option>
                      <option value="aTiempo">A tiempo</option>
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Label>Pendientes</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={selectedPendientes}
                      onChange={(e) => {
                        setSelectedPendientes(e.target.value);
                        setCurrentPage(1);
                      }}
                    >
                      <option value="Si">Con pendiente</option>
                      <option value="No">Sin pendiente (en 0)</option>
                      <option value="">Todos</option>
                    </Input>
                  </Col>
                </Row>
                <br />
                <div className="row">
                  <div className="col-md-6">
                    {vista === "tabla" ? (
                      <Pagination
                        total={totalItems}
                        itemsPerPage={ITEMS_PER_PAGE}
                        currentPage={currentPage}
                        onPageChange={(page) => setCurrentPage(page)}
                      />
                    ) : null}
                  </div>
                  <div className="col-md-6 d-flex flex-row-reverse">
                    <Search
                      onSearch={(value) => {
                        setSearch(value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
                {vista === "grafica" ? (
                  <GraficaPendientesTaller
                    filas={filtraProcesos()}
                    hoy={endDate}
                    onSelectTaller={(id) => {
                      // clic en un taller: se filtra y se ve su detalle en la tabla
                      setSelectedMaquilero(id);
                      setCurrentPage(1);
                      setVista("tabla");
                    }}
                  />
                ) : (
                <>
                <Table
                  size="sm"
                  striped
                  borderless
                  className="table-responsive-xl"
                >
                  <TableHeader
                    headers={headers}
                    onSorting={(field, order) => setSorting({ field, order })}
                  />

                  <tbody>
                    {commentsData.map((c) => {
                      totalTabla = totalTabla + c.cantidad;
                      totalEntradasTabla = totalEntradasTabla + c.totalEntradas;
                      totalPendientesTabla = totalPendientesTabla + c.pendientes;
                      return (
                        <tr>
                          <td>{c.fecha}</td>
                          <td style={{ whiteSpace: "nowrap" }}>{c.op}</td>
                          <td>{c.maquilero}</td>
                          <td>{c.proceso}</td>
                          <td>{c.articulo}</td>
                          <td>{c.color}</td>
                          <td>{c.fechaCompromiso}</td>
                          <td>{c.corte}</td>
                          <td>{c.cliente}</td>
                          {/* <td>{c.pedidoCliente}</td> */}
                          {verPrecios && <td>{fmtMoney(c.precio)}</td>}
                          <td>
                            {new Intl.NumberFormat("en-US").format(c.cantidad)}
                          </td>

                          <td>
                            {new Intl.NumberFormat("en-US").format(c.totalEntradas)}
                          </td>
                          <td>
                            {new Intl.NumberFormat("en-US").format(c.pendientes)}
                          </td>
                          <td>
                                              <Button
                                                size="sm"
                                                className="btn"
                                                color="danger"
                                                onClick={(e) =>
                                                  PDFOCPS(
                                                    c._id,
                                                    c.numero,
                                                    c.proceso,
                                                    c.maquilero,
                                                    c.pedido,
                                                    c.fechaCompromiso,
                                                    c.cantidad,
                                                    c.precio,
                                                    c.totalGeneral,
                                                    c.fecha,
                                                    c.idArticulo,
                                                    c.ordenCorte,
                                                    c.cliente
                                                  )
                                                }
                                              >
                                                <i class="far fa-file-pdf"></i>
                                              </Button>
                                            </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      {/* <td></td> */}
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        TOTAL
                      </td>
                      {verPrecios && <td></td>}
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US").format(totalTabla)}
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US").format(totalEntradasTabla)}
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US").format(totalPendientesTabla)}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </Table>
                <div className="col-md-6">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                </>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : undefined}
      {loader}
    </>
  );
}

export default CortesPendientesRecibir;
